import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import { forbiddenAccess } from './auth';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        return {
          type: types.LOGOUT_USER,
        };
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getAllowedAnalyticsReportStart() {
  return {
    type: types.GET_ALLOWED_ANALYTICS_REPORT_START,
  };
}

export function getAllowedAnalyticsReportSuccess(allowedList) {
  return {
    type: types.GET_ALLOWED_ANALYTICS_REPORT_SUCCESS,
    allowedList,
  };
}

export function getAllowedAnalyticsReportFail() {
  return {
    type: types.GET_ALLOWED_ANALYTICS_REPORT_FAIL,
  };
}

export function getAllowedAnalyticsReport() {
  return (dispatch) => {
    dispatch(getAllowedAnalyticsReportStart());
    request
      .get(`${window.Config.API_URL}/livedashboard/business/analytics_features`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getAllowedAnalyticsReportSuccess(resp.body));
        } else {
          dispatch(getAllowedAnalyticsReportFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to fetch booking software request status', ex);
        dispatch(getAllowedAnalyticsReportFail());
      });
  };
}
